import * as artifactSets from '../../core/artifacts/artifact-sets';
import * as commonEnums from '../../enums/index';
import { isCaseRunV2 } from '../../typeguards';

const { CaseArtifactTypes } = commonEnums;

export const getArtifactSet = (toggleAll: boolean, caseRun: CMxAPI.CaseRun) => {
  if (toggleAll) {
    return artifactSets.completeSet;
  } else {
    const artifacts = caseRun.artifacts ?? [];
    const artSet = isCaseRunV2(caseRun)
      ? new Set((caseRun.invoices ?? []).map(invoice => invoice.type))
      : new Set(artifacts.map(artifact => artifact.type));

    if (artSet.has(CaseArtifactTypes.SUBMITTED) || !caseRun.submitter_process) {
      return artifactSets.submissionSet;
    } else if (artSet.has(CaseArtifactTypes.PROCESSED)) {
      return artifactSets.defaultSet;
    } else {
      return artifactSets.inProgressDefaultSet;
    }
  }
};
